var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - Our version of uuid does not contain declaration types
import uuid from "uuid/v4";
import TagService from "../../../../Services/Tag.service";
import SearchField from "../../../Form/SearchField";
import { TagSearch } from "../../Tag/TagSearch";
import CheckboxField from "../../../Form/CheckboxField";
export const WAIT_FOR_TAG_APPLIED_GET_CRITERIA = (formState, { exportNodeId }) => {
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    return {
        delegates: [personLoaderDelegate],
        criteria: {
            studentPersonId: {
                isReference: true,
                workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                propertyName: "personId",
            },
            tagId: {
                value: formState.tag.id,
                isReference: false,
            },
            considerHistory: {
                value: formState.considerHistory,
                isReference: false,
            },
        },
    };
};
export const WAIT_FOR_TAG_APPLIED_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    const [tag] = yield Promise.all([
        TagService.findByIds([criteria.tagId.value]).then((tags) => tags[0]),
    ]);
    const considerHistory = criteria.considerHistory.value;
    return {
        tag,
        considerHistory,
    };
});
const WaitForTagAppliedWorkflowNodeDefinitionForm = ({ name, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(SearchField, { name: name + ".tag", label: "Tag", required: true, as: (provided) => _jsx(TagSearch, Object.assign({ includeSystemTags: true }, provided)) }), _jsx(CheckboxField, { label: "Consider Existing Data", name: name + ".considerHistory", helpText: "Checking this box will cause the automation to consider students with the tag currently applied. Leaving this box unchecked will only consider tags newly applied since this automation was created." })] }));
};
export default WaitForTagAppliedWorkflowNodeDefinitionForm;
